<section-selector>
  <a
    class="x"
    href="#"
    onclick={event => onClose(event)}
  >
    schließen
    <dfk-icon type="cross" width="20px" height="20px"></dfk-icon>
    <div is="fixed-relative"></div>
  </a>
  
  <h2>{t('sections')}</h2>

  <div class="mb-4">
    <div is="foldout">
      <div is="dfk-raw" html={t('widget_ortsgruppe')} class="text-justify" />
    </div>
  </div>

  <dfk-input
    name="terms"
    update-handler={event => onSearch(event)}
    placeholder={t('search')}
  />

  <template if={state.data}>
    <div class="header mb-3">
      <div class="d-flex flex-column align-items-end">
        <dfk-pagination
          total={state.data.total}
          page={state.data.page}
          per-page={state.data.perPage}
          page-to={values => onSearch(values)}
        />
      </div>

      <div class="d-flex justify-content-between mt-3">
        <div>
          <dfk-input
            name="filter"
            type="checkbox"
            update-handler={values => checkAll()}
          />

          alle als Filter nutzen
        </div>

        <a href="#" onclick={event => expand('all', event)}>
          alle ausklappen
        </a>
      </div>
    </div>

    <table class="table table-condensed">
      <tr>
        <th></th>
        <th>BEZEICHNUNG</th>
        <th></th>
      </tr>
      <tr each={section in state.data.sections}>
        <td class="checkbox pl-0">
          <dfk-input
            name="filter"
            type="checkbox"
            value={isActive(section)}
            update-handler={values => toggle(section)}
          />
        </td>
        <td>
          <a
            onclick={event => expand(section, event)}
            href="#"
          >
            {section.name()}
          </a>

          <div if={section.expanded}>
            <div class="mb-3">
              <div if={section.foundedAt()}>
                gegründet: {section.foundedAt()}
              </div>

              <div if={section.mentioned()}>
                früheste Erwähnung: {section.mentioned()}
              </div>
            </div>

            <div class="mb-3" if={section.comment()}>
              BEMERKUNG:<br />

              {section.comment()}
            </div>

            <div class="row mb-3">
              <div class="col-6">
                <template if={section.leaders()}>
                  ORTSGRUPPENLEITER<br />

                  <ul class="list-unstyled">
                    <li each={leader in section.leaders()}>{leader}</li>
                  </ul>
                </template>
              </div>
              <div class="col-6">
                <template if={section.people()}>
                  ARTIKEL ZU

                  <ul class="list-unstyled people">
                    <li each={person in section.people()}>
                      <dfk-input
                        name="filter"
                        type="checkbox"
                        value={isActivePerson(person)}
                        update-handler={values => togglePerson(person)}
                      />

                      {person}
                    </li>
                  </ul>
                </template>
              </div>
            </div>
          </div>
        </td>
        <td></td>
      </tr>
    </table>
  </template>

  <script>
    import * as L from 'leaflet'
    import {util, Url} from '@wendig/lib'
    import search from '../lib/search.instance'
    import config from '../lib/dotenv'
    import DfkInput from '@dfk-paris/frontend/src/components/input.riot'

    export default class {
      static components = {DfkInput}

      constructor() {
        this.onSearch = this.onSearch.bind(this)
        this.onSearch = util.delay(this.onSearch, 300)
      }

      onBeforeMount(props, state) {
        state.params = {}

        this.onSearch()
      }

      onMounted() {
        this.emit('scroll-to-top')
      }

      onSearch(values = {}) {
        if (!values['page']) values['page'] = 1

        this.state.params = Object.assign(this.state.params, values)

        this.fetch()
      }

      fetch() {
        search.sections(this.state.params).then(data => this.update({data: data}))
      }

      expand(section, event) {
        if (event) event.preventDefault()

        if (section == 'all') {
          for (const r of this.state.data.sections) {
            r.expanded = true
          }
        } else {
          section.expanded = !section.expanded
        }

        this.update()
      }

      checkAll() {
        const sections = this.state.data.sections.map(e => e.name())
        const url = Url.current()
        url.updateHashParams({section: sections.join('|')})
        url.apply()
      }

      isActive(section) {
        const url = Url.current()
        let people = url.hashParams()['section']
        people = (people ? people.split('|') : [])

        return people.includes(section.name())
      }

      toggle(section) {
        const url = Url.current()
        let sections = url.hashParams()['section']
        sections = (sections ? sections.split('|') : [])

        const i = sections.indexOf(section.name())
        if (i == -1) sections.push(section.name())
        else sections.splice(i, 1)

        url.updateHashParams({section: sections.join('|')})
        url.apply()
      }

      isActivePerson(personName) {
        const url = Url.current()
        let people = url.hashParams()['person']
        people = (people ? people.split('|') : [])

        return people.includes(personName)
      }

      togglePerson(personName) {
        const url = Url.current()
        let people = url.hashParams()['person']
        people = (people ? people.split('|') : [])

        const i = people.indexOf(personName)
        if (i == -1) people.push(personName)
        else people.splice(i, 1)

        url.updateHashParams({person: people.join('|')})
        url.apply()
      }

      onClose(event) {
        event.preventDefault()

        this.props.onClose(event)
      }
    }
  </script>
</section-selector>
